import { UseFormReturn } from 'react-hook-form'
import { selectSearchField } from '@templates/AddNewItemModal/templates'
import { Field } from '@templates/AddNewItemModal/Content'
import { SelectSearchFieldParams } from '@templates/AddNewItemModal/templates/selectSearchField'
import useJobDataForFields, {
  DEFAULT_JOB_FIELD_NAMES,
  UseJobDataForFieldsParamsType,
} from './useJobDataForFields'

type ReturnType = Record<
  'company' | 'filial' | 'division' | 'position',
  ((params?: Partial<SelectSearchFieldParams>) => Field) | null
>

const DROPDOWN_WIDTH = 400

const useJobFields = (
  methods: UseFormReturn,
  params?: UseJobDataForFieldsParamsType
): ReturnType => {
  const fieldNames = { ...DEFAULT_JOB_FIELD_NAMES, ...params?.fieldNames }
  const { company, filial, division, position } = useJobDataForFields(
    methods,
    params
  )

  return {
    company: company
      ? (params) =>
          selectSearchField({
            ...company,
            ...params,
            label: 'Компания',
            name: fieldNames.company,
            dropdownWidth: DROPDOWN_WIDTH,
          })
      : null,
    filial: filial
      ? (params) =>
          selectSearchField({
            ...filial,
            ...params,
            label: 'Филиал',
            name: fieldNames.filial,
            nameForErrors: 'companyBranch',
            dropdownWidth: DROPDOWN_WIDTH,
          })
      : null,
    division: division
      ? (params) =>
          selectSearchField({
            ...division,
            ...params,
            label: 'Подразделение',
            name: fieldNames.division,
            nameForErrors: 'subdivision',
            dropdownWidth: DROPDOWN_WIDTH,
          })
      : null,
    position: position
      ? (params) =>
          selectSearchField({
            ...position,
            ...params,
            label: 'Должность',
            name: fieldNames.position,
            nameForErrors: 'jobPosition',
            dropdownWidth: DROPDOWN_WIDTH,
          })
      : null,
  }
}

export default useJobFields
